import getLang from 'I18n/utils/getLang';
import enviro from 'enviro';
import { useEffect, useMemo, useState } from 'react';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { PUBLIC_LANGUAGES } from '../../constants/Languages';
import { getFullPublicUrl, getPublicLocalizedPathname } from '../../utils/urls';
import { MARKETING_NAV_CDN_PROD_URL, MARKETING_NAV_CDN_QA_URL, MARKETING_NAV_CDN_SCRIPT_ID } from './MarketingNav.constants';
export function useMarketingNavCdnScript({
  _useMarketingNavCdnQa = false
}) {
  const [useMarketingNavCdnQa] = useState(enviro.isQa() && (_useMarketingNavCdnQa || /_marketingNavCdnQa=true/i.test(window.location.search)));
  const [marketingNavCdnRequestState, setMarketingNavCdnRequestState] = useState('PENDING');
  useEffect(() => {
    const handleMarketingNavCdnLoad = () => {
      setMarketingNavCdnRequestState('SUCCEEDED');
    };
    const handleMarketingNavCdnFailed = () => {
      setMarketingNavCdnRequestState('FAILED');
    };
    let marketingNavCdnScript = document.getElementById(MARKETING_NAV_CDN_SCRIPT_ID);
    if (!marketingNavCdnScript) {
      marketingNavCdnScript = document.createElement('script');
      marketingNavCdnScript.setAttribute('src', useMarketingNavCdnQa ? MARKETING_NAV_CDN_QA_URL : MARKETING_NAV_CDN_PROD_URL);
      marketingNavCdnScript.setAttribute('id', MARKETING_NAV_CDN_SCRIPT_ID);
      document.body.appendChild(marketingNavCdnScript);
    }
    marketingNavCdnScript.addEventListener('load', handleMarketingNavCdnLoad);
    marketingNavCdnScript.addEventListener('error', handleMarketingNavCdnFailed);
    return () => {
      if (marketingNavCdnScript) {
        marketingNavCdnScript.removeEventListener('load', handleMarketingNavCdnLoad);
        marketingNavCdnScript.removeEventListener('error', handleMarketingNavCdnFailed);
      }
    };
  }, [useMarketingNavCdnQa]);
  useEffect(() => {
    const marketingNavCdnScript = document.getElementById(MARKETING_NAV_CDN_SCRIPT_ID);
    return () => {
      if (marketingNavCdnScript) {
        marketingNavCdnScript.remove();
      }
    };
  }, []);
  return {
    requestState: marketingNavCdnRequestState
  };
}
export function useMarketingNavLanguagesContent({
  location
}) {
  const {
    pathname,
    search
  } = location;
  const currentLang = getLang();
  return useMemo(() => {
    return PUBLIC_LANGUAGES.reduce((acc, lang) => {
      if (lang in LanguageNames) {
        const localizedPathname = `${getPublicLocalizedPathname(lang)}${pathname.replace(/^\/(de|es|fr|it|ja|nl|fi|da|no|pl|sv|pt|zh-tw|zh-cn|zh|th|ko)\/?/, '')}`.replace(/\/$/, '');
        const languageName = LanguageNames[lang];
        let languageKey = lang;
        if (lang === 'ja') {
          languageKey = 'jp';
        } else if (lang === 'zh-tw' && currentLang === 'zh') {
          languageKey = 'zh';
        }
        acc[languageKey] = [languageName, getFullPublicUrl(), `${localizedPathname}${search}`];
      }
      return acc;
    }, {});
  }, [currentLang, pathname, search]);
}